import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { makeGetRequest } from '../services/httpHelper';
import ErrorHandler from '../services/ErrorHandler';

const Section = styled.section`
  padding: 80px 20px;
  background-color: #f7f9fc;
`;

const Heading = styled.h2`
  text-align: center;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 50px;
  color: #119687;
`;

const TestimonialCard = styled(Card)`
  border: none;
  background: white;
  padding: 30px 20px;
  border-radius: 12px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.05);
  height: 100%;

  blockquote {
    font-style: italic;
    color: #333;
    margin: 0;
    font-size: 1rem;
    line-height: 1.6;
  }

  footer {
    margin-top: 20px;
    font-weight: 600;
    color: #119687;
  }
`;

const TestimonialsSection = () => {
  const church = JSON.parse(localStorage.getItem('church')) || {};

  const testimonials = church.testimonials || [
    {
      quote:
        "Ever since I joined this church, I have felt part of a warm, loving family. It's not just a place to worship, it's home.",
      name: "Sarah Mwangi",
    },
    {
      quote:
        "The teachings here have helped me grow spiritually and practically. I am grateful for this community.",
      name: "James Otieno",
    },
    {
      quote:
        "This church has been a true blessing to my family. The children's ministry is amazing and engaging.",
      name: "Grace Wanjiku",
    },
  ];


   const [idx, setIdx] = useState(0);
    const [testimonies, setTestimonies] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
  
    const getTestimonies = async () => {
      setIsLoading(true);
      const res = await makeGetRequest(`testimonials/${church.id}`);
      if (res && res.errorType) {
        setIsLoading(false);
        const errorMessage = ErrorHandler(res);
        setError(errorMessage);
      } else {
        const result = await res.data;
        if(Array.isArray(result)){
        setTestimonies(result);
        setIsLoading(false);
        setError(null);
        }
      
      }
    };
  
    useEffect(() => {
      getTestimonies();
      const interval = setInterval(() => {
        setIdx(prevIdx => (prevIdx + 1) % testimonies.length);
      }, 10000);
  
      return () => clearInterval(interval);
    }, [testimonies]);

    if (!testimonies.length) return null;

  return (
    <Section id="testimonials">
      <Container>
        <Heading>{church.testimonials_title || "What People Are Saying"}</Heading>
        <Row>
          {testimonies.map((t, index) => (
            <Col key={index} xs={12} md={4} className="mb-4 d-flex">
              <TestimonialCard>
                <blockquote>"{t.testimony}"</blockquote>
                <footer>- {t.testifier_name}</footer>
              </TestimonialCard>
            </Col>
          ))}
        </Row>
      </Container>
    </Section>
  );
};

export default TestimonialsSection;
